var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ask-question"},[_c('editWin',{attrs:{"title":"患者提问题","addApi":"/saasbaihui/saveFeedbackMessageOffline","formInputList":_vm.formInputList,"titleSplicing":false,"formatData":_vm.formatData},on:{"addSuccess":_vm.updataSuccess},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }